/**
 * Configuración API - landing-base-client
 */
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5040';

const handleResponse = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || 'Error en la solicitud');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
};

export const api = {
  get: (path, token) =>
    fetch(`${API_BASE}${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }).then(handleResponse),
  post: (path, body, token) =>
    fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(body),
    }).then(handleResponse),
};

export const endpoints = {
  eventActive: () => '/api/events/active',
  agendasByEvent: (eventId) => `/api/agendas/event/${eventId}`,
  speakersByEvent: (eventId) => `/api/speakers/event/${eventId}`,
  login: () => '/api/auth/login',
  register: () => '/api/auth/register',
  access: () => '/api/auth/access',
  surveys: () => '/api/surveys',
  configurationsActive: () => '/api/configurations/active',
  configurationsByEvent: (eventId) => `/api/configurations/event/${eventId}`,
  promotionsByEvent: (eventId) => `/api/promotions/event/${eventId}`,
};
